module.exports = __webpack_public_path__ + "assets/icons/ic_trash_24px.svg";